import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, Button } from "antd";
import { Table } from "components";
import { OrderedMap, List } from 'immutable';

class Trackwizz extends React.Component {

    state = {
        parsedEntityHitResponse: null
      };


      componentDidMount() {
        this.parseEntityHitResponse(this.props.trackwizzData?.entityHitResponse);
      }
    
      componentDidUpdate(prevProps) {
        if (prevProps.trackwizzData?.entityHitResponse !== this.props.trackwizzData?.entityHitResponse) {
          this.parseEntityHitResponse(this.props.trackwizzData?.entityHitResponse);
        }
      }

      parseEntityHitResponse(entityHitResponse) {
        if (entityHitResponse) {
          try {
            entityHitResponse = entityHitResponse.replace(/None/g, 'null').replace(/'/g, '"').trim();
            const parsedEntityHitResponse = JSON.parse(entityHitResponse);
            this.setState({ parsedEntityHitResponse });
          } catch (error) {
            console.error("Error parsing entityHitResponse:", error);
          }
        }
      }

    trackwizzCol = new OrderedMap({
        category: {
            title: "Category",
            dataIndex: "category",
            key: "category",
            render(text) {
                return {
                    props: {
                        style: {
                            height: "5rem",
                        }
                    },
                    children: text
                };
            }
        },
        value: {
            title: "Value",
            dataIndex: "value",
            key: "value",
            render(text) {
                return {
                    props: {
                        style: {
                            height: "5rem",
                        }
                    },
                    children: text
                };
            }
        }
    });
    getFormattedSources = (data, matchType) => {
        const sourceMap = {};

        data?.filter(item => item.matchType === matchType)
            .forEach(item => {
                if (!sourceMap[item.source]) {
                    sourceMap[item.source] = [];
                }
                if (!sourceMap[item.source].includes(`${item.score}%`)) {
                    sourceMap[item.source].push(`${item.score}%`);
                }
            });

        const formattedSources = Object.keys(sourceMap).map(source => {
            const scores = sourceMap[source].join(", ");
            return `${source} (${scores})`;
        });

        return formattedSources.join(", ") || "No Hit";
    }
    render() {
        const { parsedEntityHitResponse } = this.state;
        const entityData = List([{
            category: "Probable Hit",
            value: this.getFormattedSources(parsedEntityHitResponse?.hitResponse, "Probable Hit"),
        },
        {
            category: "Confirmed Hit",
            value: this.getFormattedSources(parsedEntityHitResponse?.hitResponse, "Confirm Hit"),
        }
        ])
        const actionCompany = parsedEntityHitResponse?.suggestedAction?.toUpperCase();
        return (
            <React.Fragment>
                <Card
                    title={(
                        <React.Fragment>
                            Initial Screening:{" "}
                            <span
                                style={{
                                    color: actionCompany === "PROCEED" ? "green" : actionCompany === "REVIEW" ? "red" : null,
                                }}
                            >
                                {actionCompany || "--"}
                            </span>
                        </React.Fragment>
                    )}
                    className={"padless-card small-card-title"}
                >
                    <Row gutter={16}>
                        {entityData && <Col span={8}>
                            <div className="p-10 d-flex justify-content-space-between">
                                <h4>{parsedEntityHitResponse?.sourceSystemCustomerCode || "--"}</h4>
                                <Button type="primary" disabled={!this.props.trackwizzData?.entityPdf} onClick={() => window.open(this.props.trackwizzData?.entityPdf, '_blank')}>Download Report</Button>
                            </div>
                            <Table
                                showTopSection={false}
                                pagination={false}
                                noRowSelection={true}
                                showFooter={false}
                                data={entityData}
                                columns={this.trackwizzCol}
                            />
                        </Col>}
                        {parsedEntityHitResponse?.associates_names?.map((el, index) => {
                            const applicant = this.props.trackwizzData?.applicantHitResponses[index];
                            const applicantData = List([{
                                category: "Probable Hit",
                                value: this.getFormattedSources(applicant?.hitResponse, "Probable Hit")
                            },
                            {
                                category: "Confirmed Hit",
                                value: this.getFormattedSources(applicant?.hitResponse, "Confirm Hit")
                            }
                            ])
                            const applicantPdf = this.props.trackwizzData?.applicantReportDataPdf?.split(",")[index];
                            return (
                                <Col span={8}>
                                    <div className="p-10 d-flex justify-content-space-between">
                                        <h4>{el || "--"}</h4>
                                        <Button type="primary" disabled={!applicantPdf} onClick={() => window.open(applicantPdf, '_blank')}>Download Report</Button>
                                    </div>
                                    <Table
                                        showTopSection={false}
                                        pagination={false}
                                        noRowSelection={true}
                                        showFooter={false}
                                        data={applicantData}
                                        columns={this.trackwizzCol}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </Card>
            </React.Fragment>
        );
    }
}


export default (Trackwizz);
